import React, { useState } from "react";
import { useSimularActaFirmadaMutation } from "../../libs/redux/slices/Simulab/simulabApiSlice";
import { Cabepaso, Salidasm } from "./Pasolevx";
import { ejecutar } from "./simulab";

/**
 * Paso 3 del simulador: llega la foto del acta firmada (Customs AI la lee y la manda por el mismo endpoint de siempre).
 * Firmada, CIMA registra la entrega real, soluciona la tarea y manda la constancia al cliente; sin firma, la rechaza.
 * @param {object} props
 * @param {string} props.docnroxx DO
 * @param {object} [props.foto] «Qué pasó» (actas emitidas)
 * @param {Function} props.alTerminar Refresca el «Qué pasó»
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
const Pasoacta = ({ docnroxx, foto, alTerminar }) => {
  const [simular, { isLoading }] = useSimularActaFirmadaMutation();
  const [recibe, setRecibe] = useState("PEDRO PEREZ");
  const [acta, setActa] = useState("");
  const [salida, setSalida] = useState(null);
  const pendientes = (foto?.ACTAS ?? []).filter((m) => !m.AEMFECRE || m.AEMFECRE === "0000-00-00");
  /**
   * Manda la foto del acta, con o sin firma.
   * @param {string} firmada SI | NO
   */
  const llegar = (firmada) =>
    ejecutar(simular, { DOCNROXX: docnroxx, FIRMADA: firmada, RECIBE_NOMBRE: recibe, ...(acta ? { NUMERO_ACTA: acta } : {}) },
      () => (firmada === "SI" ? "El acta firmada llegó: la entrega quedó registrada." : "Llegó sin firma."), (r) => {
        setSalida(r);
        alTerminar();
      });
  return (
    <div className="rio-card sim-paso rio-form">
      <Cabepaso numero="3" titulo="Llega la foto del acta firmada" quien="Lo hace el transportador; Customs AI la lee" />
      <div className="rio-form-grid dos">
        <label className="rio-field">Quién recibe<input value={recibe} onChange={(e) => setRecibe(e.target.value)} /></label>
        <label className="rio-field">Acta
          <select value={acta} onChange={(e) => setActa(e.target.value)}>
            <option value="">{pendientes.length > 1 ? "Elige el acta" : "La única sin entregar"}</option>
            {pendientes.map((m) => <option key={m.AEMIDXXX} value={m.AEMIDXXX}>{`${m.AEMIDXXX} · ${m.AEMPLACX || "sin placa"}`}</option>)}
          </select>
        </label>
      </div>
      <div className="sim-botones">
        <button type="button" className="sim-boton principal" disabled={isLoading} onClick={() => llegar("SI")}>Llega el acta firmada</button>
        <button type="button" className="sim-boton" disabled={isLoading} onClick={() => llegar("NO")}>Llega sin firma</button>
      </div>
      <Salidasm salida={salida} />
    </div>
  );
};

export default Pasoacta;
